export enum DominantHandEnum {
  Canhoto = "CANHOTO",
  Destro = "DESTRO",
  Ambidestro = "AMBIDESTRO"
}
